class SearchModal extends ModalDialog {
  constructor() {
    super();

    this.queryInput = this.querySelector('input[data-search-query-field]');
    this.input = this.querySelector('input[data-search-input]');
    this.filterRadios = this.querySelectorAll('[data-filter-radio]');
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    const form = this.querySelector('form');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.filterRadios.forEach((radio) => {
      radio.addEventListener('click', () => {
        let hasCheckedClass = radio.classList.contains('is-checked');

        if (hasCheckedClass) {
          this.clearCheckedState(radio);

          return;
        }

        radio
          .closest('[data-filter-radios]')
          .querySelector('.is-checked')
          ?.classList.remove('is-checked');

        radio.classList.add('is-checked');
      });
    });
  }

  show(opener) {
    super.show(opener);

    this.input.focus();
  }

  onFormSubmit() {
    const checkedFilterRadio = this.querySelector(
      '[data-filter-radio]:checked',
    );
    let filterRadioValue = checkedFilterRadio ? checkedFilterRadio.value : '';
    let queryValue = `${this.input.value.trim()} ${filterRadioValue}`;

    this.queryInput.value = queryValue.trim();

    this.input.disabled = true;
  }

  clearCheckedState(radio) {
    radio.checked = false;

    radio.classList.remove('is-checked');
  }
}

customElements.define('search-modal', SearchModal);
